import { c as _c } from "react/compiler-runtime";
import { Button, Input } from '@common/components';
import { SvgChevronleft, SvgDelete, SvgExpandWindow, SvgHome, SvgKebab, SvgLogo, SvgMagnifyingGlass, SvgNotification, SvgSetting } from '@common/icon';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { type ReactNode, useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { CustomLink } from '@/app/_components/CustomLink';
import { openShareDrawer } from '@/app/_components/GlobalModal/_components/ShareDrawer';
import SmallLogo from '@/assets/svgs/small_logo.svg';
import { DONATION_ROUTES, MODULE_ROUTES, ROUTES, SUB_DOMAIN } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { TossExitConfirmModal, useTossWebView } from '@/modules/toss';
import type { FlutterInAppWebViewWindow } from '@/modules/wello-app';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';
import { findRoute } from '@/utils';
import { gtmDatasets } from '@/utils/analytics/gtm';
import { Image } from '../Image/Image';
const TOSS_LOGO_URL = 'https://cdn.welfarehello.com/static/toss-logo.png';
type NavigationRouter = Pick<ReturnType<typeof useCustomRouter>, 'push' | 'replace' | 'back'>;
export type PageNavigationContentProps = PageNavigationProps & {
  isToss: boolean;
  isKbWebview: boolean;
  pathname: string;
  router?: NavigationRouter;
  openConfirmModal?: VoidFunction;
  closeConfirmModal?: VoidFunction;
  confirmAndClose?: VoidFunction;
  isModalOpened?: boolean;
};
const PageNavigationContent = t0 => {
  const $ = _c(95);
  const {
    logo,
    logoHref,
    title,
    titleLeft,
    children,
    backButton: t1,
    backButtonType: t2,
    searchButton,
    bellButton,
    notification,
    shareButton,
    settingsButton,
    kebabButton,
    onClickBack,
    onClickKebab,
    hideHomeButton,
    className,
    style,
    textColor,
    isNotUsedHomeButton,
    donationHomeButton,
    backgroundColor,
    searchForm,
    searchFormDefaultValue,
    searchFormClassName,
    onSearchFormMount,
    onSearchFormClick,
    onSearchFormSubmit,
    isToss,
    pathname,
    router,
    openConfirmModal,
    closeConfirmModal,
    confirmAndClose,
    isModalOpened
  } = t0;
  const backButton = t1 === undefined ? true : t1;
  const backButtonType = t2 === undefined ? "back" : t2;
  const hasBottomNav = findRoute(pathname)?.hasBottomNav;
  const t3 = router?.push ?? _temp;
  const t4 = router?.replace ?? _temp2;
  const t5 = router?.back ?? _temp3;
  let t6;
  if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5) {
    t6 = {
      push: t3,
      replace: t4,
      back: t5
    };
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const safeRouter = t6;
  let t7;
  if ($[4] !== openConfirmModal) {
    t7 = () => openConfirmModal?.();
    $[4] = openConfirmModal;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const handleOpenConfirm = t7;
  let t8;
  if ($[6] !== closeConfirmModal) {
    t8 = () => closeConfirmModal?.();
    $[6] = closeConfirmModal;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const handleCloseConfirm = t8;
  let t9;
  if ($[8] !== confirmAndClose) {
    t9 = () => confirmAndClose?.();
    $[8] = confirmAndClose;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const handleConfirmAndClose = t9;
  const modalOpened = Boolean(isModalOpened);
  const DEFAULT_LOGO_HREF = isToss ? DONATION_ROUTES.HOME.pathname : ROUTES.HOME.pathname;
  let t10;
  if ($[10] !== className) {
    t10 = cn("relative flex min-h-48 w-full items-center", "box-border select-none bg-Gray-white text-center", className);
    $[10] = className;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = backgroundColor === "gray" ? "#f3f3f3" : undefined;
  let t12;
  if ($[12] !== style || $[13] !== t11) {
    t12 = {
      backgroundColor: t11,
      ...style
    };
    $[12] = style;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== textColor || $[16] !== titleLeft) {
    t13 = titleLeft ? <h3 className={cn("absolute left-20 font-700 flex-center typo-h6", textColor)}>{titleLeft}</h3> : null;
    $[15] = textColor;
    $[16] = titleLeft;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== textColor || $[19] !== title) {
    t14 = title ? <h3 className={cn("absolute flex size-full items-center justify-center", "break-all text-center font-600 text-Gray-900 typo-body3", textColor)}>{title}</h3> : null;
    $[18] = textColor;
    $[19] = title;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== DEFAULT_LOGO_HREF || $[22] !== isToss || $[23] !== logo || $[24] !== logoHref) {
    t15 = logo ? <div className="flex items-center gap-12"><div className={cn("flex items-center gap-12", {
        "gap-2": isToss
      })}>{isToss ? <><Image src={TOSS_LOGO_URL} alt="toss" width={31} height={31} /><SvgDelete className="size-20 text-Gray-400" /></> : null}<CustomLink aria-label={"\uC6F0\uB85C"} href={logoHref ?? DEFAULT_LOGO_HREF} {...gtmDatasets.clickGnb({
          menu_name: "\uB85C\uACE0"
        })}>{logo === "symbol" ? <SmallLogo className="size-40" /> : <SvgLogo className="h-29 w-86" />}</CustomLink></div></div> : null;
    $[21] = DEFAULT_LOGO_HREF;
    $[22] = isToss;
    $[23] = logo;
    $[24] = logoHref;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== backButton || $[27] !== backButtonType || $[28] !== onClickBack || $[29] !== safeRouter || $[30] !== textColor) {
    t16 = backButton ? <Button aria-label={"\uB4A4\uB85C \uAC00\uAE30"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={onClickBack ? typeof onClickBack === "string" ? () => safeRouter.replace(onClickBack) : onClickBack : () => safeRouter.back()}>{backButtonType === "back" ? <SvgChevronleft className={cn("size-24", textColor)} /> : <SvgDelete className={cn("size-24", textColor)} />}</Button> : null;
    $[26] = backButton;
    $[27] = backButtonType;
    $[28] = onClickBack;
    $[29] = safeRouter;
    $[30] = textColor;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== hasBottomNav || $[33] !== hideHomeButton || $[34] !== isNotUsedHomeButton || $[35] !== safeRouter || $[36] !== textColor) {
    t17 = !hasBottomNav && !isNotUsedHomeButton ? <Button aria-label={"\uD648\uC73C\uB85C \uAC00\uAE30"} className={cn("relative size-26 p-0", hideHomeButton && "hidden")} dimensions="H26" theme="primary-text" onClick={() => safeRouter.push(ROUTES.HOME.pathname)}><SvgHome className={cn("size-24", textColor)} /></Button> : null;
    $[32] = hasBottomNav;
    $[33] = hideHomeButton;
    $[34] = isNotUsedHomeButton;
    $[35] = safeRouter;
    $[36] = textColor;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== donationHomeButton || $[39] !== safeRouter || $[40] !== textColor) {
    t18 = donationHomeButton ? <Button aria-label={"\uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80 \uD648\uC73C\uB85C \uAC00\uAE30"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={() => safeRouter.push(DONATION_ROUTES.HOME.pathname)}><SvgHome className={cn("size-24", textColor)} /></Button> : null;
    $[38] = donationHomeButton;
    $[39] = safeRouter;
    $[40] = textColor;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== onSearchFormClick || $[43] !== onSearchFormMount || $[44] !== onSearchFormSubmit || $[45] !== searchForm || $[46] !== searchFormClassName || $[47] !== searchFormDefaultValue) {
    t19 = searchForm ? <Input ref={el => {
      if (!el) {
        return;
      }
      onSearchFormMount?.(el);
    }} key={searchFormDefaultValue} type="search" placeholder={"\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694"} dimensions="H40" defaultValue={searchFormDefaultValue} className={cn("my-12 w-full select-text border-none bg-Gray-200 text-Gray-900 placeholder:text-Gray-550 focus:border-none", searchFormClassName)} onClick={() => onSearchFormClick?.()} onKeyDown={e => {
      if (e.key === "Enter") {
        onSearchFormSubmit?.(e.currentTarget.value);
      }
    }} onClear={() => onSearchFormSubmit?.("")} /> : null;
    $[42] = onSearchFormClick;
    $[43] = onSearchFormMount;
    $[44] = onSearchFormSubmit;
    $[45] = searchForm;
    $[46] = searchFormClassName;
    $[47] = searchFormDefaultValue;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== t15 || $[50] !== t16 || $[51] !== t17 || $[52] !== t18 || $[53] !== t19) {
    t20 = <div className="z-[1] flex min-w-0 grow items-center gap-20 pl-20">{t15}{t16}{t17}{t18}{t19}</div>;
    $[49] = t15;
    $[50] = t16;
    $[51] = t17;
    $[52] = t18;
    $[53] = t19;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== searchButton || $[56] !== textColor) {
    t21 = searchButton ? <Button aria-label={"\uAC80\uC0C9\uC73C\uB85C \uC774\uB3D9"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" asChild={true} {...gtmDatasets.clickGnb({
      menu_name: "\uAC80\uC0C9"
    })}><CustomLink href={typeof searchButton === "boolean" ? ROUTES.SEARCH.pathname : searchButton}><SvgMagnifyingGlass className={cn("size-24", textColor)} /></CustomLink></Button> : null;
    $[55] = searchButton;
    $[56] = textColor;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== bellButton || $[59] !== notification || $[60] !== safeRouter || $[61] !== textColor) {
    t22 = bellButton ? <Button aria-label={"\uC54C\uB9BC\uC73C\uB85C \uC774\uB3D9"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={() => {
      safeRouter.push(ROUTES.PUSH.pathname);
    }}><SvgNotification className={cn("size-24", textColor)} />{notification ? <span className="absolute right-14 top-12 box-content size-4 rounded-pill border-2 border-Gray-100 bg-R-500" /> : null}</Button> : null;
    $[58] = bellButton;
    $[59] = notification;
    $[60] = safeRouter;
    $[61] = textColor;
    $[62] = t22;
  } else {
    t22 = $[62];
  }
  let t23;
  if ($[63] !== shareButton || $[64] !== textColor) {
    t23 = shareButton ? <Button aria-label={"\uACF5\uC720\uD558\uAE30"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={_temp4}><SvgExpandWindow className={cn("size-24", textColor)} /></Button> : null;
    $[63] = shareButton;
    $[64] = textColor;
    $[65] = t23;
  } else {
    t23 = $[65];
  }
  let t24;
  if ($[66] !== safeRouter || $[67] !== settingsButton || $[68] !== textColor) {
    t24 = settingsButton ? <Button aria-label={"\uC124\uC815"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={() => safeRouter.push(ROUTES.MY_SETTINGS.pathname)}><SvgSetting className={cn("size-24", textColor)} /></Button> : null;
    $[66] = safeRouter;
    $[67] = settingsButton;
    $[68] = textColor;
    $[69] = t24;
  } else {
    t24 = $[69];
  }
  let t25;
  if ($[70] !== kebabButton || $[71] !== onClickKebab || $[72] !== textColor) {
    t25 = kebabButton ? typeof kebabButton === "boolean" ? <Button aria-label={"\uB354\uBCF4\uAE30"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={onClickKebab}><SvgKebab className={cn("size-24", textColor)} /></Button> : kebabButton : null;
    $[70] = kebabButton;
    $[71] = onClickKebab;
    $[72] = textColor;
    $[73] = t25;
  } else {
    t25 = $[73];
  }
  let t26;
  if ($[74] !== handleCloseConfirm || $[75] !== handleConfirmAndClose || $[76] !== handleOpenConfirm || $[77] !== isToss || $[78] !== modalOpened) {
    t26 = isToss ? <><Button aria-label={"\uD1A0\uC2A4\uB85C \uC774\uB3D9"} className="relative h-26 whitespace-nowrap p-0" dimensions="H40" theme="primary-text" onClick={handleOpenConfirm}>닫기</Button><TossExitConfirmModal opened={modalOpened} onClose={handleCloseConfirm} onConfirm={handleConfirmAndClose} /></> : null;
    $[74] = handleCloseConfirm;
    $[75] = handleConfirmAndClose;
    $[76] = handleOpenConfirm;
    $[77] = isToss;
    $[78] = modalOpened;
    $[79] = t26;
  } else {
    t26 = $[79];
  }
  let t27;
  if ($[80] !== children || $[81] !== t21 || $[82] !== t22 || $[83] !== t23 || $[84] !== t24 || $[85] !== t25 || $[86] !== t26) {
    t27 = <div className="z-[1] ml-auto flex shrink-0 justify-end gap-20 px-20">{t21}{t22}{children}{t23}{t24}{t25}{t26}</div>;
    $[80] = children;
    $[81] = t21;
    $[82] = t22;
    $[83] = t23;
    $[84] = t24;
    $[85] = t25;
    $[86] = t26;
    $[87] = t27;
  } else {
    t27 = $[87];
  }
  let t28;
  if ($[88] !== t10 || $[89] !== t12 || $[90] !== t13 || $[91] !== t14 || $[92] !== t20 || $[93] !== t27) {
    t28 = <nav aria-label={"\uD398\uC774\uC9C0 \uB0B4\uBE44\uAC8C\uC774\uC158"} className={t10} style={t12}>{t13}{t14}{t20}{t27}</nav>;
    $[88] = t10;
    $[89] = t12;
    $[90] = t13;
    $[91] = t14;
    $[92] = t20;
    $[93] = t27;
    $[94] = t28;
  } else {
    t28 = $[94];
  }
  return t28;
};
export interface PageNavigationProps {
  className?: string;
  title?: string | ReactNode;
  titleLeft?: string | ReactNode;
  children?: ReactNode;
  logo?: 'full' | 'symbol';
  logoHref?: string;
  searchButton?: boolean | string;
  bellButton?: boolean;
  shareButton?: boolean;
  notification?: boolean;
  settingsButton?: boolean;
  backButton?: boolean;
  backButtonType?: 'exit' | 'back';
  /** backButton 유무와 관계없이 뒤로가기 활성화 */
  enableHistoryBack?: boolean;
  kebabButton?: boolean | ReactNode;
  onClickKebab?: VoidFunction;
  hideHomeButton?: boolean;
  onClickBack?: VoidFunction | string;
  style?: React.CSSProperties;
  textColor?: string;
  isNotUsedHomeButton?: boolean;
  donationHomeButton?: boolean;
  /** logo가 true일 때 렌더링 되는 video backgroundColor에 영향을 줌 */
  backgroundColor?: 'gray';
  //* 검색 폼 관련
  searchForm?: boolean;
  searchFormDefaultValue?: string;
  searchFormClassName?: string;
  onSearchFormMount?: (ref: HTMLInputElement) => void;
  onSearchFormClick?: () => void;
  onSearchFormSubmit?: (value: string) => void;
}
export const PageNavigation = props => {
  const $ = _c(54);
  const {
    logo,
    logoHref,
    title,
    titleLeft,
    children,
    backButton: t0,
    backButtonType: t1,
    enableHistoryBack,
    searchButton,
    bellButton,
    notification,
    shareButton,
    settingsButton,
    kebabButton,
    onClickBack,
    onClickKebab,
    hideHomeButton,
    className,
    style,
    textColor,
    isNotUsedHomeButton,
    donationHomeButton,
    backgroundColor,
    searchForm,
    searchFormDefaultValue,
    searchFormClassName,
    onSearchFormMount,
    onSearchFormClick,
    onSearchFormSubmit
  } = props;
  const backButton = t0 === undefined ? true : t0;
  const backButtonType = t1 === undefined ? "back" : t1;
  const router = useCustomRouter();
  const {
    openConfirmModal,
    closeConfirmModal,
    confirmAndClose,
    isModalOpened
  } = useTossWebView();
  const [isKbWebview, setAppModal, isToss, isWelloApp] = useDeviceInfoStore(useShallow(_temp5));
  let t2;
  if ($[0] !== backButton || $[1] !== enableHistoryBack || $[2] !== router || $[3] !== setAppModal) {
    t2 = () => {
      const _window = window as FlutterInAppWebViewWindow;
      if (_window.router) {
        _window.router.back = backButton || enableHistoryBack ? () => router.back() : () => {
          setAppModal({
            isOpened: true,
            type: "exit"
          });
        };
        return () => {
          _window.router.back = _temp6;
        };
      }
    };
    $[0] = backButton;
    $[1] = enableHistoryBack;
    $[2] = router;
    $[3] = setAppModal;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== backButton || $[6] !== enableHistoryBack || $[7] !== isWelloApp || $[8] !== router || $[9] !== setAppModal) {
    t3 = [backButton, enableHistoryBack, isWelloApp, router, setAppModal];
    $[5] = backButton;
    $[6] = enableHistoryBack;
    $[7] = isWelloApp;
    $[8] = router;
    $[9] = setAppModal;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t2, t3);
  const pathname = usePathname() ?? "";
  const shouldHideNavigation = isKbWebview && pathname !== MODULE_ROUTES.KB_HOME.pathname;
  let t4;
  if ($[11] !== backButton || $[12] !== backButtonType || $[13] !== backgroundColor || $[14] !== bellButton || $[15] !== children || $[16] !== className || $[17] !== closeConfirmModal || $[18] !== confirmAndClose || $[19] !== donationHomeButton || $[20] !== enableHistoryBack || $[21] !== hideHomeButton || $[22] !== isKbWebview || $[23] !== isModalOpened || $[24] !== isNotUsedHomeButton || $[25] !== isToss || $[26] !== kebabButton || $[27] !== logo || $[28] !== logoHref || $[29] !== notification || $[30] !== onClickBack || $[31] !== onClickKebab || $[32] !== onSearchFormClick || $[33] !== onSearchFormMount || $[34] !== onSearchFormSubmit || $[35] !== openConfirmModal || $[36] !== pathname || $[37] !== router || $[38] !== searchButton || $[39] !== searchForm || $[40] !== searchFormClassName || $[41] !== searchFormDefaultValue || $[42] !== settingsButton || $[43] !== shareButton || $[44] !== style || $[45] !== textColor || $[46] !== title || $[47] !== titleLeft) {
    t4 = {
      logo,
      logoHref,
      title,
      titleLeft,
      children,
      backButton,
      backButtonType,
      enableHistoryBack,
      searchButton,
      bellButton,
      notification,
      shareButton,
      settingsButton,
      kebabButton,
      onClickBack,
      onClickKebab,
      hideHomeButton,
      className,
      style,
      textColor,
      isNotUsedHomeButton,
      donationHomeButton,
      backgroundColor,
      searchForm,
      searchFormDefaultValue,
      searchFormClassName,
      onSearchFormMount,
      onSearchFormClick,
      onSearchFormSubmit,
      isToss,
      isKbWebview,
      pathname,
      router,
      openConfirmModal,
      closeConfirmModal,
      confirmAndClose,
      isModalOpened
    };
    $[11] = backButton;
    $[12] = backButtonType;
    $[13] = backgroundColor;
    $[14] = bellButton;
    $[15] = children;
    $[16] = className;
    $[17] = closeConfirmModal;
    $[18] = confirmAndClose;
    $[19] = donationHomeButton;
    $[20] = enableHistoryBack;
    $[21] = hideHomeButton;
    $[22] = isKbWebview;
    $[23] = isModalOpened;
    $[24] = isNotUsedHomeButton;
    $[25] = isToss;
    $[26] = kebabButton;
    $[27] = logo;
    $[28] = logoHref;
    $[29] = notification;
    $[30] = onClickBack;
    $[31] = onClickKebab;
    $[32] = onSearchFormClick;
    $[33] = onSearchFormMount;
    $[34] = onSearchFormSubmit;
    $[35] = openConfirmModal;
    $[36] = pathname;
    $[37] = router;
    $[38] = searchButton;
    $[39] = searchForm;
    $[40] = searchFormClassName;
    $[41] = searchFormDefaultValue;
    $[42] = settingsButton;
    $[43] = shareButton;
    $[44] = style;
    $[45] = textColor;
    $[46] = title;
    $[47] = titleLeft;
    $[48] = t4;
  } else {
    t4 = $[48];
  }
  const contentProps = t4;
  if (shouldHideNavigation) {
    return null;
  }
  let t5;
  if ($[49] !== className) {
    t5 = cn("sticky top-0 z-20 hidden mobile-tablet:flex", className);
    $[49] = className;
    $[50] = t5;
  } else {
    t5 = $[50];
  }
  let t6;
  if ($[51] !== contentProps || $[52] !== t5) {
    t6 = <PageNavigationContent {...contentProps} className={t5} />;
    $[51] = contentProps;
    $[52] = t5;
    $[53] = t6;
  } else {
    t6 = $[53];
  }
  return t6;
};
function _temp() {}
function _temp2() {}
function _temp3() {}
function _temp4() {
  openShareDrawer(location.href);
}
function _temp5(state) {
  return [state.webviewType === WEBVIEW_TYPE.KB_PAY, state.setAppModal, state.subDomain === SUB_DOMAIN.TOSS, state.webviewType === WEBVIEW_TYPE.WELLO_APP] as const;
}
function _temp6() {}